import React, { useState } from 'react';
import styled from "styled-components";

const TooltipContainer = styled.div`
position: relative;
  display: inline-block;
  &:hover{
    display: block;
    opacity: 1; /* Show the tooltip with smooth transition */
  }
`;

const StakedToolTip = styled.div`
    position: absolute;
    background-color: ${(props)=>props.isList==true?"#083a52":"#067a0b"};
    color: ${(props)=>props.isList==true?"#1b7be1":"#20e928"};
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    text-transform: capitalize;
    z-index: 999;
    border-radius: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    top: -60px;
    left: 10px;
    box-shadow: 0px 0px 10px 5px #0a3e096b;
    transition: opacity 0.3s ease-in-out;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    
`;

const ListedImg = styled.img`
padding-right:10px;
width: 30px;
`;

const Tooltip = ({ text, children,isList }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <TooltipContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children}
      {/* {showTooltip && <StakedToolTip><ListedImg src={ListedIcon}/> {text}</StakedToolTip>} */}
      {showTooltip && <StakedToolTip isList={isList}> {text}</StakedToolTip>}
    </TooltipContainer>
  );
};

export default Tooltip;